'use client'


import SocialMedia from "../header/social";
import { useLocale } from 'next-intl';
import { useRouter } from 'next/navigation';
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/routing";
import { PiContactlessPaymentLight } from "react-icons/pi";
import { PiContactlessPaymentFill } from "react-icons/pi";
import { PiContactlessPaymentBold } from "react-icons/pi";
import { PiContactlessPaymentThin } from "react-icons/pi";

const Footer = () => {
  const router = useRouter(); // Initialize the router
  const locale = useLocale(); // Get the current locale
  const t = useTranslations('Footer');
  // Function to handle navigation with query parameters
  const handleNavigateWithQuery = ( query: string) => {
    // Include the locale and query parameters in the URL
    router.push(`/${locale}/p?q=${encodeURIComponent(query)}`);
  };

    return (
        <footer className="bg-neutral">
        <div className="mx-6 md:mx-16 custom:mx-72 py-20 ">
          <div className="grid  grid-cols-2  custom:grid-cols-4 gap-10">
            {/* Contact & Follow Section */}
            <div className="col-span-2 md:col-span-1">
            <h2 className="mb-4 font-bold   uppercase">{t('Contact Us')}</h2>
            <div className="text-sm text-gray-700">
               <p>{t('Contact Us text')}</p>
            <p>{t('Contact Us text 1')}</p>
           <p className="font-bold mt-2">
  <a 
    href="mailto:contact@padlev.com"
    className="hover:underline transition-all duration-200 hover:text-bl"
    title="Send email to contact@padlev.com"
  >
    contact@padlev.com
  </a>
</p>
                 <button
                  onClick={() => router.push(`/${locale}/contact-us`)}
                    className="mt-4 px-6 py-2 font-bold bg-secondary hover:bg-yel  text-yel hover:text-secondary rounded-md  gap-3 uppercase flex justify-center items-center">
                {t('Contact Us')}
                 <PiContactlessPaymentThin size={24} aria-hidden="true" />
                  </button>
            </div>
           
              
            </div>
            <div className="col-span-2 md:col-span-1">
            <h2 className="pb-4 font-bold uppercase">{t('Follow us')}</h2>
            <p className="text-sm text-gray-700 mb-2">{t('Follow us text')}</p>
             <SocialMedia/>
            </div>
            {/* Information Section */}
            <div className="col-span-1">
            <h2 className="pb-4 font-bold uppercase">{t('Support & Info')}</h2>
          <div className="text-gray-700 text-sm flex flex-col gap-3">
            <Link href="/help"><p className="hover:text-bl hover:underline cursor-pointer">{t('help')}</p></Link>
            <Link href="/about-us"> <p className="hover:text-bl hover:underline cursor-pointer">{t('about us')} </p></Link>
            <Link href="/charity"><p className="hover:text-bl hover:underline cursor-pointer">{t('Charity')}</p></Link>
            <Link href="/returns-and-refunds"> <p className="hover:text-bl hover:underline cursor-pointer">{t('Returns and Refunds')}</p></Link>

          </div>
             
            </div>
            {/* Useful Links Section */}
            <div className="col-span-1">
            <h2 className="pb-4 font-bold uppercase">{t('PRODUCTS')}</h2>
            <div className="text-gray-700 text-sm flex flex-col gap-3">
            <p className="hover:text-bl hover:underline cursor-pointer" onClick={() => handleNavigateWithQuery('rkb,'+'rki,'+'rkp')}>{t('rackets')}</p>
            <p className="hover:text-bl hover:underline cursor-pointer" onClick={() => handleNavigateWithQuery('sw,'+'sm')}>{t('shoes')}</p>
            <p className="hover:text-bl hover:underline cursor-pointer" onClick={() => handleNavigateWithQuery('bl,'+'gri,'+'ogri,'+'rkpt,'+'ptg,'+'sung,'+'twl,'+'rb,'+'wb,'+'swb')}>{t('accessories')}</p>
             <p className="hover:text-bl hover:underline cursor-pointer" onClick={() => handleNavigateWithQuery('bgs')}>{t('bags')}</p>
            <p className="hover:text-bl hover:underline cursor-pointer" onClick={() => handleNavigateWithQuery('tsm,'+'swsm,'+'sockm,'+'srtm,'+'psm,'+'lptsm,'+'legm,'+'jcktm,'+'capm,')}>{t('man clothes')}</p>
            <p className="hover:text-bl hover:underline cursor-pointer" onClick={() => handleNavigateWithQuery('drs,'+'vsr,'+'top,'+'tswm,'+'swsw,'+'sockw,'+'srtw,'+'psw,'+'lptsw,'+'legw,'+'jcktw,'+'capw,')}>{t('woman clothes')}</p>
          </div>
          
            </div>
            {/* Footer Text Spanning All Columns */}
        
          </div>
        </div>
      </footer>
      
    );
  };
  
  export default Footer;
  